import { render, staticRenderFns } from "./order-delivery-date-display.vue?vue&type=template&id=b764a2f6&"
import script from "./order-delivery-date-display.vue?vue&type=script&lang=ts&"
export * from "./order-delivery-date-display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b764a2f6')) {
      api.createRecord('b764a2f6', component.options)
    } else {
      api.reload('b764a2f6', component.options)
    }
    module.hot.accept("./order-delivery-date-display.vue?vue&type=template&id=b764a2f6&", function () {
      api.rerender('b764a2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/orders/components/order-delivery-date-display.vue"
export default component.exports